import { render, staticRenderFns } from "./init_tem.vue?vue&type=template&id=4d2ecfff&scoped=true&"
import script from "./init_tem.vue?vue&type=script&lang=js&"
export * from "./init_tem.vue?vue&type=script&lang=js&"
import style0 from "./init_tem.vue?vue&type=style&index=0&id=4d2ecfff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ecfff",
  null
  
)

export default component.exports